import { cva, type VariantProps } from 'class-variance-authority';

/**
 * Gradient ring wrapper — pairs with `.gradient-border` in `index.css` (masked `::before`).
 */
const gradientBorderVariants = cva('gradient-border [&>*]:relative [&>*]:z-10');

export type GradientBorderVariantProps = VariantProps<typeof gradientBorderVariants>;

export { gradientBorderVariants };
